export default {
  required: {
    value: 'This field is required',
    class: 'is-danger'
  },
  emailFormat: {
    value: 'Please enter a valid email',
    class: 'is-danger'
  },
  emailDuplicate: {
    value: 'An account with this email already exist. Please use another.',
    class: 'is-danger'
  },
  passwordRequirement: {
    value: 'Password must be at least 6 characters long, contain one number and one uppercase letter'
  },
  parentSignup: {
    value: 'If the Participant is under 18 years old, a parental/guardian section will open up and is required to complete sign-up.'
  },
  minimumAge: {
    value: 'Participants under 18 years old require parent consent',
    class: 'is-info'
  },
  minLength: {
    value: 'Password must have at least 6 characters',
    class: 'is-danger'
  },
  passwordsMatch: {
    value: 'Passwords do not match',
    class: 'is-danger'
  },
  passwordError: {
    value: 'Password must be at least 6 characters long, contain one number and one uppercase letter',
    class: 'is-danger'
  },
  countryRequired: {
    value: 'Please select a country',
    class: 'is-danger'
  },
  stateSelectRequired: {
    value: 'Please select a state',
    class: 'is-danger'
  },
  stateValueRequired: {
    value: 'Please provide a state/region/district',
    class: 'is-danger'
  },
  emptyField: {
    value: 'Field cannot be empty',
    class: 'is-danger'
  },
  validUrl: {
    value: 'URL must be a valid Youtube link',
    class: 'is-danger'
  }
}
